import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Order } from '../order.interface';

@Component({
  selector: 'app-card-pay',
  templateUrl: './card-pay.component.html',
  styleUrls: ['./card-pay.component.scss']
})
export class CardPayComponent implements OnChanges {
  @Input() order: Order;
  @Input() amount: number;
  paidByCard;
  paidByCash;

  constructor() {}

  ngOnChanges() {
    if (this.order) {
      if (this.order.trip) {
        this.paidByCard = (this.order.trip.invoices || [])
          .filter(invioce => invioce.status == 'hold_approved')
          .map(invoice => invoice.amount)
          .reduce((a, b) => a + b);
        this.paidByCash =
          (this.amount || this.order.fare.amount) - this.paidByCard;
      } else {
        this.paidByCard = this.amount || this.order.fare.amount;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/card-pay/card-pay.component.ts